import { Icon, Typography } from '@mui/material';
import { transparentize } from 'polished';
import { memo, useCallback } from 'react';
import styled, { css } from 'styled-components';

import FQCard, { FQCARD_VARIANTS } from '@/components/muiCustomized/FQCard/FQCard';
import { AbsenceTypeResponseDto } from '@/domain/myOrganization';
import { FONT_SIZE, FONT_WEIGHT } from '@/globalStyles';

interface IRequestTypeCardProps {
    className?: string;
    absenceType: AbsenceTypeResponseDto;
    isSelected?: boolean;
    setValue: (value: AbsenceTypeResponseDto) => void;
    daysLeft?: number;
    noLimits?: boolean;
}

const SingleRequestTypeCard = ({ absenceType, setValue, className }: IRequestTypeCardProps) => {
    const { name, color, icon } = absenceType || {};

    const handleClick = useCallback(() => {
        setValue(absenceType);
    }, [absenceType, setValue]);

    return (
        <FQCard onClick={handleClick} data-variant={FQCARD_VARIANTS.fqMediumRequestType} className={className}>
            <Icon sx={{ color }}>{icon}</Icon>
            <Typography noWrap variant="menu_categories">
                {name}
            </Typography>
        </FQCard>
    );
};

const Memoized = memo(SingleRequestTypeCard);
const Styled = styled(Memoized)`
    margin: 2rem 2rem 0 0;

    .MuiTypography-root {
        font-weight: ${FONT_WEIGHT.normal};
        max-width: 100%;
    }

    .MuiIcon-root {
        font-size: ${FONT_SIZE.xxlargepx};
        margin-bottom: 0.7rem;
    }

    :hover {
        background-color: ${({ absenceType }) => !!absenceType?.color && transparentize(0.95, absenceType?.color)};
    }

    ${({ isSelected, absenceType }) =>
        isSelected &&
        css`
            && {
                background-color: ${!!absenceType?.color && transparentize(0.9, absenceType?.color)};
                .MuiTypography-root {
                    font-weight: ${FONT_WEIGHT.medium};
                }
                &:after {
                    background-color: ${absenceType?.color};
                }
            }
        `}
`;

export default Styled;
